module.exports = __webpack_public_path__ + "img/show-less.618f6532.svg";